module.exports = __webpack_public_path__ + "img/SieWissenSichZuVerteidigen.368b9734.jpg";